import { render, staticRenderFns } from "./UserRolesList.vue?vue&type=template&id=821433ba&scoped=true"
import script from "./UserRolesList.vue?vue&type=script&lang=js"
export * from "./UserRolesList.vue?vue&type=script&lang=js"
import style0 from "./UserRolesList.vue?vue&type=style&index=0&id=821433ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821433ba",
  null
  
)

export default component.exports